import styled from "styled-components";
import { colors } from "../../assets";

export const MascotasCoveragesTableContainer = styled.div`
  margin-bottom: 55px;
  min-width: 100%;
  max-width: 450px;
  overflow-x: auto;

  &:last-child {
    margin-bottom: 0;
  }

  .checkbox-container input:not(:checked) {
    color: ${colors["TX-001-50"]};
  }

  .checkbox-container {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 15px;

    div:nth-of-type(2) {
      line-height: 25px;
      font-size: 16px;
    }

    &:hover {
      input ~ .checkmark {
        background-color: rgba(0, 79, 139, 0.3);
      }
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

      &:checked ~ .checkmark-container {
        background: #e8f9f5;
        justify-content: flex-end;

        .checkmark-item {
          background: #40caa9;
        }

        img {
          max-width: 14px;
        }
      }
    }

    p:first-of-type {
      white-space: initial;
    }
  }

  .checkmark-container {
    min-width: 24px;
    background: #ffffff;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 14px;
    transition: 0.3s all ease-in-out;
    border-radius: 5px;

    img {
      max-width: 14px;
    }
  }

  .checkmark-item {
    background: ${colors["TX-001-30"]};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    width: 20px;
    height: 20px;
  }

  .coverage-row {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .money {
      white-space: nowrap;
      padding-top: 5px;
    }

    .main-money {
      white-space: nowrap;
      padding: 30px 15px;
    }
  }
`;
